import { useEffect, useMemo, useState } from "react";
import { Paper } from "@mui/material";
import { useDoctorContext } from "../../contexts";
import { Doctor } from "../../models";
import { SearchInput } from "./SearchInput";

interface FaceToFaceDoctorSearchProps {
	label?: string;
	value?: string;
	onDoctorSelect?: (doctor?: Doctor) => void;
}

export const FaceToFaceDoctorSearch = ({
	label = "Doctor",
	value,
	onDoctorSelect
}: FaceToFaceDoctorSearchProps) => {
	const { faceToFaceDoctors } = useDoctorContext();
	const [searchValue, setSearchValue] = useState("");

	useEffect(() => {
		setSearchValue(value ?? "");
	}, [value]);

	const handleSearchValueChange = (nextValue: string) => {
		setSearchValue(nextValue);

		if (nextValue.trim() === "" && value) {
			onDoctorSelect?.(undefined);
		}
	};

	const filteredDoctors = useMemo(() => {
		const searchTerm = searchValue.trim().toLowerCase();
		if (searchTerm.length < 1) {
			return [];
		}

		return (faceToFaceDoctors ?? []).filter((doctor) =>
			doctor.displayName.toLowerCase().includes(searchTerm)
		);
	}, [faceToFaceDoctors, searchValue]);

	const handleDoctorClick = (doctor?: Doctor) => {
		setSearchValue(doctor?.displayName ?? "");
		onDoctorSelect?.(doctor);
	};

	const selectedDoctorDisplayName = value?.trim().toLowerCase() ?? "";
	const shouldShowDropdown =
		searchValue.trim().length > 0 &&
		searchValue.trim().toLowerCase() !== selectedDoctorDisplayName;

	return (
		<div style={{ position: "relative", width: "100%" }}>
			<SearchInput
				label={label}
				value={searchValue}
				handleSearchValueChange={handleSearchValueChange}
				handleClear={() => handleDoctorClick(undefined)}
			/>
			{shouldShowDropdown && (
				<Paper
					elevation={3}
					style={{
						position: "absolute",
						top: "100%",
						left: 0,
						right: 0,
						zIndex: 10,
						maxHeight: 400,
						overflowY: "auto",
						marginTop: 8
					}}
				>
					{filteredDoctors.length > 0 ? (
						filteredDoctors.map((doctor) => (
							<button
								key={doctor.id}
								type="button"
								onClick={() => handleDoctorClick(doctor)}
								style={{
									display: "block",
									width: "100%",
									padding: "12px 16px",
									textAlign: "left",
									border: 0,
									background: "transparent",
									cursor: "pointer"
								}}
							>
								{doctor.displayName}
							</button>
						))
					) : (
						<div style={{ padding: "12px 16px" }}>No doctors found</div>
					)}
				</Paper>
			)}
		</div>
	);
};
